goog.provide('el8.ptdata.patients');
goog.provide('el8.ptdata.model.patient');

// This file is required by most patient model files and is
// expected not to require any models
goog.require('el8.data.practiceUsers');
goog.require('el8.model.base');
goog.require('el8.ptdata.model.ptInsurance');
goog.require('el8.ptdata.model.guarantor');
goog.require('el8.ptdata.model.consents');

// HACK WARNING!
//
// Commenting out this goog.require because Closure deps ordering breaks badly. This module is
// goog.required in the module that precipitated this ordering issue: prenatalFlowsheet.js
// so that it will be guaranteed to be loaded.
//
// See hccScoreDetails.js for another example of forced import required to fix broken deps ordering.
//
// goog.require('el8.ptdata.ptTags');

goog.require('el8.template.ptdata.patients');
goog.require('el8.util.base');

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDeleteable();
    _class.addAddressProperties(); // address, suite, city, state, zip, addressLine, cityStateZip
    _class.addStringProperty('suite', true); // suite is not always included in asMap

    _class.addStringProperty('firstName', true);
    _class.addStringProperty('middleName', true);
    _class.addStringProperty('lastName', true);
    _class.addStringProperty('actualName', true);
    _class.addDate('dob', true);
    _class.addStringProperty('sex', true);
    _class.addStringProperty('displaySex', true);

    _class.addIntProperty('age', true);
    _class.addStringProperty('displayAge', true);
    _class.addBoolean('verified', true);
    _class.addProperty('tagIds', false, []); // not in asMap because they have their endpoint

    _class.addBoolean('demo', true);
    _class.addStringProperty('ssn', true);
    _class.addStringProperty('chartNumber', true);

    _class.addStringProperty('email', true);
    _class.addStringProperty('phone1', true);
    _class.addStringProperty('phone1Type', true);
    _class.addStringProperty('phone2', true);
    _class.addStringProperty('phone2Type', true);
    _class.addStringProperty('passportPhone');

    _class.addModelProperty('primaryInsurance', el8.ptdata.model.ptInsurance, true);
    _class.addModelProperty('secondaryInsurance', el8.ptdata.model.ptInsurance, true);

    _class.addIntProperty('preferredLanguageId', true);

    _class.addIntProperty('race', true); // the top-level category
    _class.addStringProperty('displayRace', true);
    _class.addStringProperty('raceCode', true); // the top-level category as code
    _class.addStringProperty('detailedRace', true); // the full CDC race as code

    _class.addIntProperty('secondaryRace', true);
    _class.addStringProperty('detailedSecondaryRace', true);

    _class.addIntProperty('ethnicity', true);
    _class.addStringProperty('displayEthnicity', true);
    _class.addStringProperty('detailedEthnicity', true);

    _class.addIntProperty('secondaryEthnicity', true);
    _class.addStringProperty('detailedSecondaryEthnicity', true);

    _class.addStringProperty('preferredContact', true);

    _class.addStringProperty('sexualOrientation', true);
    _class.addStringProperty('genderIdentity', true);
    _class.addStringProperty('displayGenderIdentity', true);

    _class.addIntProperty('primaryPhysicianUserId', true);
    _class.addStringProperty('primaryPhysicianName', true);

    _class.addStringProperty('notes', true);

    // "next of kin," presented as "emergency contact" in the UI
    _class.addStringProperty('nokFirstName', true);
    _class.addStringProperty('nokLastName', true);
    _class.addStringProperty('nokRelationship', true);
    _class.addStringProperty('nokAddress', true);
    _class.addStringProperty('nokSuite', true);
    _class.addStringProperty('nokCity', true);
    _class.addStringProperty('nokState', true);
    _class.addStringProperty('nokZip', true);
    _class.addStringProperty('nokPhone', true);

    _class.addModelProperty('guarantor', el8.ptdata.model.guarantor, true, {});

    _class.addStringProperty('referringProvider', true);
    _class.addStringProperty('referringProviderState', true);
    _class.addIntProperty('referringProviderCanonicalId', true);

    _class.addStringProperty('pcpPhysicianName', true);
    _class.addIntProperty('pcpCanonicalId', true);

    _class.addBoolean('vip', true);

    _class.addProperty('consents', true, []);


    // Note: this is PatientEmployer. Just a string for LabCorp worker's
    // comp claims. NOT the DPC-related Employer model. Calling patientEmployer
    // to avoid conflict with Employer which sets the _employer prop.
    _class.addStringProperty('patientEmployer', true);

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);
        // load tags into the ptTags cache and store just the ids in here
        if (spec.tags) {
          el8.ptdata.ptTags.create(spec.tags, true);
          this.setTagIds(_.pluck(spec.tags, 'id'));
        }

        if (spec.consents) {
            el8.ptdata.model.consents.create(spec.consents, true);
        }
    };

    /**
     * HELPER METHODS
     */
    _class.prototype.getEitherPhone = function() {
        return this.getPhone1() || this.getPhone2();
    }
    _class.prototype.getEitherPhoneType = function() {
        if (this.getPhone1()) {
            return "(" + this.getPhone1Type() + ")";
        }
        else if (this.getPhone2()) {
            return "(" + this.getPhone2Type() + ")";
        }
        return "";
    }
    _class.prototype.getLanguage = function() {
        if (this.getPreferredLanguageId()) {
            return el8.data.languages.getById(this.getPreferredLanguageId());
        }
        return null;
    };
    _class.prototype.getMobilePhone = function() {
        if (this.getPhone1Type() === 'Cell Phone') {
            return this.getPhone1();
        } else if (this.getPhone2Type() === 'Cell Phone') {
            return this.getPhone2();
        }
        return null;
    };
    _class.prototype.getFullName = function() {
        return el8.template.ptdata.patients.fullName(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.getDisplayName = function() {
        return el8.template.ptdata.patients.displayName(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.getReverseName = function() {
        return el8.template.ptdata.patients.reverseName(this.asSoyMap()).el8_unescape();
    };

    _class.prototype.getTags = function() {
        return this.getTagIds().map(function(id) {
            return el8.ptdata.ptTags.getById(id);
        });
    };
    _class.prototype.getTagValues = function() {
        return this.getTagIds().map(function(id) {
            var tag = el8.ptdata.ptTags.getById(id);
            return tag ? tag.getValue() : null;
        });
    };

    _class.prototype.softLoadKareoId = function(successCb) {
        var that = this;
        if (that._kareoIdLoaded) {
            successCb(that._kareoId);
        } else {
            $.el8_ajax({
                url: el8.service.urls.get('kareoPatientId', [that.getId()]),
                type: 'GET',
                success: function(data) {
                    that._kareoIdLoaded = true;
                    that._kareoId = data.kareo_id;
                    successCb(that._kareoId);
                }
            });
        }
    };

    _class.prototype.softLoadIntegrations = function(successCb) {
        var that = this;
        if (that._integrationsLoaded) {
            successCb(that._integrations);
        } else {
            $.el8_ajax({
                url: el8.service.urls.get('patientIntegrations', [that.getId()]),
                type: 'GET',
                success: function(data) {
                    that._integrationsLoaded = true;
                    that._integrations = data;
                    successCb(that._integrations);
                }
            });
        }
    };

    _class.prototype.loadEmployer = function(successCb) {
        var that = this;
        $.el8_ajax({
            url: el8.service.urls.get('patientEmployer', [that.getId()]),
            type: 'GET',
            success: function(data) {
                that._employer = data;
                successCb(that._employer);
            }
        });
    };

    _class.prototype.loadSmsShortCodeStatus = function(successCb) {
        var that = this;
        $.el8_ajax({
            url: el8.service.urls.get('smsShortCodeStatus', [el8Globals.PRACTICE_ID, that.getId()]),
            type: 'GET',
            success: function(data) {
                that._smsShortCodeStatus = data.data;
                successCb(that._smsShortCodeStatus);
            }
        });
    }

    _class.prototype.asAutocompleteMap = function() {

        var m = {};
        m['id'] = this.getId();
        m['age'] = this.getDisplayAge();
        m['dob'] = this.getDob() ? this.getDob().asString() : null;
        m['name'] = this.getLastName() + ', ' + this.getFirstName() + ' ' + this.getMiddleName();
        m['primaryPhysicianUserId'] = this.getPrimaryPhysicianUserId();
        m['sex'] = this.getSex();
        m['tags'] = this.getTagValues().join(', ');
        m['practice_id'] = el8Globals.PRACTICE_ID;

        m['url'] = '/patient/'+this.getId()+'/';

        // NOT AVAILABLE ON CLIENT
        m['last_seen'] = null;
        m['contact'] = null;
        m['next_appt'] = null;
        m['verified'] = null;

        return m;
    };

    _class.prototype.asFormMap = function() {
        var data = {};
        var map = this.asSoyMap();
        for (var key in map) {
            if (map.hasOwnProperty(key)) {
                // only adds an entry for key if map[key] is non-empty
                el8.util.setOptKey(data, key, map[key]);
            }
        }
        return data;
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        var language = this.getLanguage();
        mapped['preferredLanguageName'] = (language) ? language.getName() : null;
        mapped['addressLine'] = this.getAddressLine();
        mapped['cityStateZip'] = this.getCityStateZip();
        delete mapped['tagIds'];
        mapped['tags'] = this.getTagValues();

        return mapped;
    };

    el8.ptdata.patients = (function() {
        return new el8_EntitySet({
            model: function(spec) { return new _class(spec); },
            items: [],
            urlFn: function(id) { return '/s/get/patient-id/full/'+id+'/'; }
        });

    })();
})();
